import { Table, TableBody, TableHead } from '@mui/material';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { mutate } from 'swr';
import deleteTenant from '../../../api/tenant/deleteTenant';
import { TenantContext } from '../../../contexts/tenantContext';
import { TableCellHead, TableRowStyled, TableContainerStyled } from '../styled';
import { TenantsListInterface, TenantInterface } from '../tenantsInterface';
import TableRow from './tableRow';

const TableTenantsList: FC<TenantsListInterface> = ({ tenants }) => {
    const { t } = useTranslation('settings');
    const [selectedSchema] = useContext(TenantContext) ?? [];
    const tenantsUrl = `${process.env.REACT_APP_API_URL}/tenant`;
    const refreshMutate = () => {
        mutate(tenantsUrl);
    };
    const handleDeleteTenant = (tenantId: number, tenantName: string) => {
        deleteTenant(tenantId, t('tenants.modal.successDeleteTenant', { tenantName }), t('tenants.modal.errorDeleteTenant', { tenantName }), refreshMutate, selectedSchema || '');
    };

    const tableCell = [
        { key: 'name', label: t('tenants.tableCell.name') },
        { key: 'numberOfsurveys', label: t('tenants.tableCell.numberOfsurveys') },
        { key: 'actions', label: '' },
    ];

    return (
        <TableContainerStyled>
            {tenants && (
                <Table sx={{ width: 'fit-content', minWidth: 500, marginBottom: '3rem' }}>
                    <TableHead>
                        <TableRowStyled>
                            {tableCell.map((cell) => (
                                <TableCellHead key={cell.key} id={cell.key}>{cell.label}</TableCellHead>
                            ))}
                        </TableRowStyled>
                    </TableHead>
                    <TableBody>
                        {tenants?.map((tenant: TenantInterface) => (
                            <TableRow
                                key={tenant.id}
                                handleDeleteTenant={handleDeleteTenant}
                                id={tenant.id}
                                tenantName={tenant.label}
                                tenantSurveysCount={tenant.surveysCount}
                            />
                        ))}
                    </TableBody>
                </Table>
            )}
        </TableContainerStyled>
    );
};

export default TableTenantsList;
